export const TranslationValues = {
	siteName: 'ConsumerLoanPublic',
	listName: 'Resources',
	keyGroups: {
		global: 'global',
	},
};
